import Section from "components/layout/section"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import { TFunction } from "i18next"
import { useTranslation } from "react-i18next"
import PageTitle from "features/navigation/pageTitle"
import RightSidebar from "@/components/sidebar/right/RightSidebar"
import Collapse from "@/components/collapse/Collapse"
import Hint from "@/components/text/Hint"
import LegalLinks from "@/components/legal/LegalLinks"
import Button from "@/components/inputs/button"
import { APP_CONFIG } from "constants/constants"
import { ReactComponent as StoragesIcon } from "assets/icons/home_storage.svg"
import { ReactComponent as CategoryIcon } from "assets/icons/category.svg"
import { ReactComponent as TuneIcon } from "assets/icons/discover_tune.svg"
import { ReactComponent as DeleteIcon } from "assets/icons/delete.svg"
import { ReactComponent as GroupAddIcon } from "assets/icons/group_add.svg"
import { ReactComponent as HouseIcon } from "assets/icons/house.svg"
import { ReactComponent as UpgradeIcon } from "assets/icons/upgrade.svg"
import { ReactComponent as GroupIcon } from "assets/icons/group.svg"
import { ReactComponent as TransactionsIcon } from "assets/icons/description.svg"
import { ReactComponent as ShippingIcon } from "assets/icons/shipping.svg"
import { ReactComponent as RestoreIcon } from "assets/icons/restore.svg"
import { ReactComponent as ActionsIcon } from "assets/icons/actions.svg"
import { ReactComponent as LanguageIcon } from "assets/icons/language.svg"
import { ReactComponent as ListIcon } from "assets/icons/format_list_bulleted.svg"

const MAX_STORAGES_PER_USER = 50

const FAQ_ITEMS = [
    { questionKey: "faqQuestionWhatIsStorage", answerKey: "faqAnswerWhatIsStorage", Icon: HouseIcon },
    { questionKey: "faqQuestionHowManyStorages", answerKey: "faqAnswerHowManyStorages", Icon: StoragesIcon },
    { questionKey: "faqQuestionWhatIsCategory", answerKey: "faqAnswerWhatIsCategory", Icon: CategoryIcon },
    { questionKey: "faqQuestionCustomFields", answerKey: "faqAnswerCustomFields", Icon: TuneIcon },
    { questionKey: "faqQuestionInvite", answerKey: "faqAnswerInvite", Icon: GroupAddIcon },
    { questionKey: "faqQuestionRoles", answerKey: "faqAnswerRoles", Icon: GroupIcon },
    { questionKey: "faqQuestionPlans", answerKey: "faqAnswerPlans", Icon: UpgradeIcon },
    { questionKey: "faqQuestionStock", answerKey: "faqAnswerStock", Icon: ActionsIcon },
    { questionKey: "faqQuestionTransactions", answerKey: "faqAnswerTransactions", Icon: TransactionsIcon },
    { questionKey: "faqQuestionCustomersSuppliers", answerKey: "faqAnswerCustomersSuppliers", Icon: ShippingIcon },
    { questionKey: "faqQuestionDeleteStorage", answerKey: "faqAnswerDeleteStorage", Icon: RestoreIcon },
    { questionKey: "faqQuestionDeleteAccount", answerKey: "faqAnswerDeleteAccount", Icon: DeleteIcon },
    { questionKey: "faqQuestionRestore", answerKey: "faqAnswerRestore", Icon: RestoreIcon },
    { questionKey: "faqQuestionLanguage", answerKey: "faqAnswerLanguage", Icon: LanguageIcon },
] as const

const tParagraphs = (t: TFunction, key: string, options?: Record<string, string | number>) => {
    const value = t(key, { returnObjects: true, ...options })
    if (Array.isArray(value)) return value.map(String)
    return [String(value)]
}

const FaqPage = () => {
    const { t } = useTranslation()

    const interpolation = {
        maxStorages: MAX_STORAGES_PER_USER,
        graceDays: APP_CONFIG.PERMANENT_DELETION_GRACE_DAYS,
    }

    return (
        <>
            <PageTitle title={t("titleFaq")} />
            <Section>
                <p>{t("faqIntro")}</p>
                <Hint>{t("faqHint")}</Hint>
                <div className="flex flex-col gap-2 md:flex-row md:flex-wrap">
                    <Button wideOnMobile design="white" to="/pricing">
                        <UpgradeIcon />
                        <span>{t("buttonViewPricing")}</span>
                    </Button>
                </div>
            </Section>
            <Section>
                <div className="flex flex-col gap-y-2">
                    {FAQ_ITEMS.map(({ questionKey, answerKey, Icon }) => {
                        const question = t(questionKey)
                        return (
                            <Collapse key={questionKey} textOpen={question} textClosed={question} icon={<Icon />}>
                                {tParagraphs(t, answerKey, interpolation).map((paragraph) => (
                                    <p key={paragraph}>{paragraph}</p>
                                ))}
                            </Collapse>
                        )
                    })}
                </div>
            </Section>
            <RightSidebar />
        </>
    )
}

export default FaqPage
